import { Component, inject, Injector, OnInit } from '@angular/core';
import { BaseTableComponent } from '../../../shared/class/base-table-component.class';
import { Organization } from '../../../shared/models/Organization.model';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { environment } from '../../../../environments/environment';
import { AccessString } from '../../../auth/enums/access-string.enum';
import { AccessType } from '../../../auth/enums/access-type.enum';
import { ActionString } from '../../../auth/enums/action-string.const';
import { PageAccess } from '../../../auth/models/page-access.model';
import { AppHttpService } from '../../../shared/services/app-http.service';
import { ConfirmationService } from 'primeng/api';
import { MessageType } from '../../../shared/enums/message-type.enum';
import { Pagination } from '../../../shared/models/table.model';

@Component({
  selector: 'app-list-org',
  templateUrl: './list-org.component.html',
  styleUrl: './list-org.component.scss'
})
export class ListOrgComponent extends BaseTableComponent implements OnInit {
  orgList: Organization[] = [];
  protected accessType!: AccessType;
  protected accessString!: AccessString;
  protected accessTypes = AccessType;
  protected pageAccess: PageAccess = {};
  public appBaseUrl = environment.API_URL;
  accessCode = AccessType;
  orgIdToDelete: number | null = null;

  ngOnInit(): void {
    this.subscription.add(
      this.route.queryParamMap.subscribe(param => {
        this.updateQueryParam(param);
        this.getOrgRecords(param);
      })
    );
  }

  constructor(private confirmationService: ConfirmationService) {
    super();
  }

  onPageChange(page: any) {
    this.currentPage = Math.round(page.first / page.rows);
    this.perPage = page.rows;

    const payload = {
      pageIndex: this.currentPage,
      pageSize: this.perPage
    }
    this.onPageEvent(payload, '/settings/org');
  }
  
  async getOrgRecords(filterPayload: any | undefined) {
    let pagination: Pagination = {
      limit: this.perPage,
      skip: this.currentPage * this.perPage,
      take: this.perPage,
      order: {
        createdAt: 'DESC',
      }
    };

    filterPayload = {
      limit: pagination.limit,
      skip: pagination.skip,
      take: pagination.take,
      order: pagination.order,
      ...filterPayload.params
    }

    let response: ApiResponse<any> = await this.httpService.httpRequest<Organization>(
      "organization",
      "find-all-and-count-by-admin",
      filterPayload
    );
    if (response.status && response.data) {
      this.orgList = response.data![0] ?? [];
      this.totalRecords = response.data?.[1] ?? 0;
    }
  }
  // Confirmation for delete
  confirmDelete(orgId: number, event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Do you want to delete this Organization?',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button',
      accept: () => {
        this.orgIdToDelete = orgId;
        this.deleteOrg();
      },
      reject: () => {
        this.notificationService.notify('Organization Deletion Cancelled', MessageType.Error)
      }
    });
  }

  async deleteOrg() {
    if (this.orgIdToDelete) {
      const payload = {
        id: this.orgIdToDelete
      }
      let response: ApiResponse<any> = await this.httpService.httpRequest<Organization>(
        "organization",
        "delete",
        payload
      );
      if (response.status && response.data) {
        location.reload();
        this.notificationService.notify('Organization Deleted Successfully', MessageType.Success)
      } else {
        this.notificationService.notify('Unable to Delete Organization', MessageType.Error)
      }
      this.orgIdToDelete = null;
    }
  }
}
